import { Button } from "@rumble-it/common-components/components";
import { Checkbox } from "@/components/form/checkbox";
import { Link } from "react-router-dom";

/**
 * Users
 */
type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: {
    name: string;
  };
}[];
export const formatUsers = (data: User) =>
  data
    ? data.map((item) => ({
        id: item.id,
        firstName: <Link to={`/users/${item.id}`}>{item.firstName}</Link>,
        lastName: item.lastName,
        email: item.email,
        role: item.role?.name,
        show: (
          <Link to={`/users/${item.id}`}>
            <Button
              variant="greyLight"
              size="iconSmall"
              faIcon={{ style: "fal", name: "eye" }}
            />
          </Link>
        ),
      }))
    : null;

export const formatUser = (data: { id: string; name: string }) => ({
  id: data.id,
  name: data.name,
});

export const formatUsersAsSelect = (data: { id: string; name: string }[]) =>
  data
    ? data.map((item) => ({
        id: item.id,
        name: item.name,
      }))
    : null;

/**
 * Permissions
 */
type Permission = {
  id: string;
  name: string;
  description: string;
}[];
export const formatUserPermissions = (data: Permission) =>
  data
    ? data.map((item) => ({
        id: item.id,
        name: <Link to={`/users/permissions/${item.id}`}>{item.name}</Link>,
        description: item.description,
        // TODO Preferable allow the table to handle the link?
        show: (
          <Link to={`/users/permissions/${item.id}`}>
            <Button
              variant="greyLight"
              size="iconSmall"
              faIcon={{ style: "fal", name: "eye" }}
            />
          </Link>
        ),
      }))
    : null;

type UserPermission = {
  id: string;
  name: string;
  event_name: string;
};
export const formatUserPermission = (data: UserPermission) => ({
  id: data.id,
  name: data.name,
  event_name: data.event_name,
});

export const formatUserPermissionsAsSelect = (
  data: { id: string; name: string }[],
) =>
  data
    ? data.map((item) => ({
        id: `/users/permissions/${item.id}`,
        name: item.name,
      }))
    : null;

/**
 * Roles
 */
type Role = {
  id: string;
  name: string;
  pending: boolean;
  dealershipRequired: boolean;
  system: boolean;
}[];
export const formatUserRoles = (data: Role) =>
  data
    ? data.map((item) => ({
        id: item.id,
        name: <Link to={`/users/roles/${item.id}`}>{item.name}</Link>,
        pending: <Checkbox checked={item.pending} />,
        dealershipRequired: <Checkbox checked={item.dealershipRequired} />,
        system: <Checkbox checked={item.system} />,
        show: (
          <Link to={`/users/roles/${item.id}`}>
            <Button
              variant="greyLight"
              size="iconSmall"
              faIcon={{ style: "fal", name: "eye" }}
            />
          </Link>
        ),
      }))
    : null;

type UserRole = {
  id: string;
  name: string;
  event_name: string;
};
export const formatUserRole = (data: UserRole) => ({
  id: data.id,
  name: data.name,
  event_name: data.event_name,
});

type RolePermission = {
  id: string;
  name: string;
}[];
export const formatUserRolesAsSelect = (data: RolePermission) =>
  data
    ? data.map((item) => ({
        id: item.id,
        name: item.name,
      }))
    : null;

export const formatUserPermissionsOnRole = (data: RolePermission[]) =>
  data ? data.map((permission) => (permission as any)["@id"]) : null;
